import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as ReplyLogo } from "../../assets/images/landing/logo/logo-reply.svg";
import StaticMediaLink from "../utils/StaticMediaLink";

function LandingFooter() {
  return (
    <div className="landing-footer">
      <div className="footer-wrap">
        <StaticMediaLink
          url="/static-media/files/reply-online-services-privacy-and-cookie-policy.pdf"
          classNames="privacy label medium"
        >
          Privacy &amp; Cookie Policy
        </StaticMediaLink>
        <Link to="/accessibility-statement" target="_blank" className="accessibility label medium">
          Accessibility statement
        </Link>
      </div>
      <div className="strip">
        <div className="footer-logo">
          <ReplyLogo />
        </div>

        <div>
          <p className="address footer-voices light-contrast mb-0">
            Reply S.p.A. - Corso Francia, 110 &#8211; 10143 Turin, Italy.{" "}
            <br className="d-none d-lg-block" /> Paid in Capital 4,863,485.64 Euros Company Register
            of Turin/Fiscal Code: 97579210010, Vat number IT 08013390011
          </p>
        </div>
      </div>
    </div>
  );
}

export default LandingFooter;
